import React from "react";
import styled from "styled-components";

export default (props) => {
  return (
    <Div>
      {props.messages}
      <Cross onClick={props.onClick}>✖</Cross>
    </Div>
  );
};

const Div = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #345d9d;
  height: 40px;
  padding-top: 8px;
  padding-bottom: 8px;
  padding-left: 10px;
  color: white;
`;

const P = styled.p`
  color: white;
  display: table-cell;
  vertical-align: middle;
  text-align: center;
`;
const Cross = styled.button`
  background-color: #345d9d;
  border: none;
  color: white;
  font-size: 20px;
  padding-left: 13px;
  padding-right: 20px;
  float: right;

  display: table-cell;
  vertical-align: middle;
  text-align: center;
`;
